module.exports = __webpack_public_path__ + "media/images/level_introduction5-68eac2e1e9228ad944b37fe7fc2dfac4.png";